<div *ngIf="isMomentumEdge()" class="bg-gradient-to-r from-momentum-deep_purple from-[37%] to-momentum-black">
  <div class="max-w-screen-xl text-white mx-auto py-2 text-xs px-4 text-right"><a class=" hover:underline pl-2" [href]="environment.fulcrumUrl">Agency Portal Log In</a></div>
</div>
<div class="max-w-screen-xl mx-auto mb-20 bg-agentium_white-backdrop" [ngClass]="getSkinClass()">
  <nav *ngIf="isAgentium()" class="border-gray-200">
    <div class="flex flex-wrap items-center max-w-screen-xl mx-auto py-4 lg:px-4">
      <a [href]="environment.agentiumUrl" class="flex items-center space-x-3 rtl:space-x-reverse pl-4 lg:pl-0">
        <img src="../../../assets/agentium-logo.png" class="max-w-40 sm:max-w-[246px]" alt="agentium logo" height="87"
             width="246" />
      </a>
      <a *ngIf="logoImageUrl && stateAssociation?.url" [href]="stateAssociation?.url" target="_blank" rel="noopener noreferrer">
        <img [src]="logoImageUrl" [alt]="'logo: ' + stateAssociation?.name" />
      </a>
      <a>
        <img *ngIf="logoImageUrl && !stateAssociation?.url" [src]="logoImageUrl" [alt]="'logo: ' + stateAssociation?.name" />
      </a>
      <div class="flex items-end lg:order-2 space-x-1 lg:space-x-2 rtl:space-x-reverse pr-4 lg:pr-0 ml-auto lg:ml-8">
        <a
          [href]="environment.agentiumUrl + '/get-a-demo/'"
          class="button px-5 py-2 text-sm text-agentium_blue-primary hover:text-white hover:bg-agentium_blue-primary rounded-full font-bold border border-agentium_blue-primary"
        >Get a Demo</a
        >
        <button
          data-collapse-toggle="mega-menu"
          type="button"
          class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="mega-menu"
          aria-expanded="false"
        >
          <span class="sr-only">Open main menu</span>
          <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15" />
          </svg>
        </button>
      </div>
      <div id="mega-menu" class="bg-[--nav-bg-color] lg:bg-transparent lg:ml-auto hidden w-full mb-6 shadow lg:shadow-none lg:mb-0 lg:flex lg:w-auto lg:order-1">
        <ul class="flex flex-col font-medium lg:flex-row md:mt-0 rtl:space-x-reverse lg:space-x-8">
          <li>
            <a [href]="environment.agentiumUrl + '/agents/'" class="nav-link">Agent Solutions</a>
          </li>
          <li>
            <a [href]="environment.agentiumUrl + '/partner-programs/'" class="nav-link">Partner Programs</a>
          </li>
          <li>
            <a href="/admin/all-referrals" class="nav-link">Log In</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <nav *ngIf="isMomentumEdge()" class="border-gray-200 mb-6">
    <div class="flex flex-wrap items-center max-w-screen-xl mx-auto py-4 lg:px-4">
      <!-- Show default logo only when NOT loading and NO state association exists -->
      <a *ngIf="!isLoadingLogo && !stateAssociation" [href]="environment.wwwUrl + '/advantage/'" class="flex items-center space-x-3 rtl:space-x-reverse pl-4 lg:pl-0 relative md:top-[8px]">
        <img src="assets/momentum-edge-logo-dark.png" class="max-w-64 sm:max-w-[180px]" alt="Momentum Edge logo" height="40" width="180" />
      </a>

      <!-- Show state logo WITH url when loaded -->
      <div *ngIf="!isLoadingLogo && logoImageUrl && stateAssociation?.url" class="flex items-center pl-4 lg:pl-0 relative md:top-[8px]">
        <a [href]="environment.wwwUrl + '/advantage/'"><img src="assets/edge-logo-state-association-lockup.png" class="max-w-32 sm:max-w-36" /></a><a [href]="stateAssociation?.url" target="_blank" rel="noopener noreferrer"><img [src]="logoImageUrl" [alt]="stateAssociation?.name + ' logo'" class="max-w-32 sm:max-w-36 max-h-[85px] sm:max-h-[95px] ml-2.5"/></a>
      </div>

      <!-- Show state logo WITHOUT url when loaded -->
      <div *ngIf="!isLoadingLogo && logoImageUrl && !stateAssociation?.url && stateAssociation" class="flex items-center pl-4 lg:pl-0 relative md:top-[8px]">
        <a [href]="environment.wwwUrl + '/advantage/'"><img src="assets/edge-logo-state-association-lockup.png" class="max-w-32 sm:max-w-36" /></a><img [src]="logoImageUrl" [alt]="stateAssociation.name + ' logo'" class="max-w-32 sm:max-w-36 max-h-[85px] sm:max-h-[95px] ml-2.5"/>
      </div>

      <!-- Optional: Show loading placeholder while fetching -->
      <div *ngIf="isLoadingLogo" class="flex items-center pl-4 lg:pl-0 relative md:top-[8px] opacity-50">
        <img src="assets/edge-logo-state-association-lockup.png" class="max-w-32 sm:max-w-36" />
        <div class="max-w-32 sm:max-w-36 max-h-[85px] sm:max-h-[95px] ml-2.5 flex items-center justify-center">
          <span class="text-gray-400">Loading...</span>
        </div>
      </div>

      <div class="flex items-center relative sm:top-2.5 xl:order-2 space-x-1 xl:space-x-2 rtl:space-x-reverse pr-4 xl:pr-0 ml-auto xl:ml-8">
        <a
          [href]="environment.momentumEdgeUrl + '/agents-demo/'"
          class="hidden sm:block button px-7 py-1 text-center text-[19px] text-momentum-deep_purple hover:text-white hover:bg-momentum-royal_purple rounded-[4px] font-bold border-2 border-momentum-deep_purple hover:border-momentum-royal_purple min-w-36"
        >Get a Demo</a
        >
        <button
          data-collapse-toggle="mega-menu"
          type="button"
          class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-momentum-black rounded-lg xl:hidden hover:bg-gray-100 focus:outline-none"
          aria-controls="mega-menu"
          aria-expanded="false"
          (click)="toggleMegaMenu()"
          [attr.aria-expanded]="isMegaMenuOpen"
        >
          <span class="sr-only">Open main menu</span>
          <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15" />
          </svg>
        </button>
      </div>
      <div id="mega-menu"  class="xl:mx-auto xl:relative xl:top-3 xl:mt-0 bg-[--nav-bg-color] xl:bg-transparent hidden w-full mb-6 shadow xl:shadow-none xl:mb-0 xl:flex xl:w-auto xl:order-1"
           [ngClass]="!stateAssociation ? 'mt-3' : 'mt-5'"
           [class.hidden]="!isMegaMenuOpen">
        <ul class="flex flex-col font-medium xl:flex-row md:mt-0 rtl:space-x-reverse xl:space-x-12">
          <li>
            <a [href]="environment.wwwUrl + '/independent-agents/'" class="nav-link">Agent Advantage</a>
          </li>
          <li>
            <a [href]="environment.wwwUrl + '/claim-it/'" class="nav-link">Agent Claim-it</a>
          </li>
          <li>
            <a [href]="environment.wwwUrl + '/agents-buy-now/'" class="nav-link">Plans</a>
          </li>
          <li>
            <a [href]="environment.wwwUrl + '/category/success-stories/'" class="nav-link">Success Stories</a>
          </li>
          <li class="sm:hidden">
            <div class="py-5 text-center bg-gray-200">
              <a
                [href]="environment.wwwUrl + '/agents-demo/'"
                class="inline-block button px-7 py-1 text-center text-[19px] text-momentum-deep_purple hover:text-white bg-white hover:bg-momentum-royal_purple rounded-full font-bold border-2 border-momentum-deep_purple hover:border-momentum-royal_purple min-w-[148px] mr-5"
              >Get a Demo</a
              >
              <a
                [href]="environment.wwwUrl + '/agents-buy-now/'"
                class="inline-block button px-7 py-1 text-center text-[19px] bg-momentum-deep_purple text-white rounded-full font-bold border-2 border-momentum-deep_purple hover:bg-momentum-royal_purple hover:border-momentum-royal_purple min-w-[148px]"
              >Buy Now</a
              >
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div *ngIf="isAgentium()" class="text-center mb-10 px-4">
    <h1 class="text-agentium_blue-primary text-3xl sm:text-4xl md:text-5xl mb-1 sm:mb-3">Insurance Referral Feed</h1>
    <div class="text-slate-600 text-base sm:text-xl max-w-4xl mx-auto">
      Take a look at our real-time view of opportunities being delivered to independent agents right now! See the kinds of referrals you can expect from Agentium.
    </div>
  </div>

  <div *ngIf="isMomentumEdge()" class="text-center mb-10 px-4">
    <h1 class="text-momentum-deep_purple text-3xl sm:text-4xl md:text-5xl mb-1 sm:mb-3 font-semibold font-poppins">Insurance Referral Feed</h1>
    <div class="text-momentum-black text-xl max-w-3xl mx-auto">What kind of referrals can you expect? Check out our real-time view of opportunities being delivered to independent agents right now!</div>
  </div>

  <div>
    <app-all-referrals
      [enableDetailsPanel]="false"
      [columnsToDisplay]="columnsToDisplay"
      [showDateFilter]="false"
      [showStateFilter]="true"
      [showHeader]="false"
      [pageTitle]="pageTitle"
      [selectedDateFilter]="'72hours'"
      [selectedStateCodeFilter]="null"
      [showPrices]="false"
      [loadGeoIpStateFilter]="false"
      [sortField]="'addDate'"
      [sortOrder]="'desc'"
      [showExpiration]="false"
      [showClaimed]="true"
    ></app-all-referrals>
  </div>
</div>

<div *ngIf="isMomentumEdge()" class="py-20 md:py-36 relative bg-gradient-to-r from-momentum-deep_purple from-[37%] to-momentum-black">
  <div class="max-w-screen-md mx-auto text-white my-auto text-center">
    <div class="text-3xl sm:text-4xl md:text-6xl mb-2 font-semibold font-poppins">Be Understood, Be Found and Get Recommended</div>
    <div class="font-semibold text-xl sm:text-2xl mb-10 px-4">Don't miss out on being recognized as a top tier agency in your area and getting connected to high-intent prospects.</div>
    <a [href]="environment.wwwUrl + '/independent-agents/'" class="py-3 px-8 rounded-[4px] hover:bg-momentum-edge_yellow hover:text-momentum-black border-momentum-edge_yellow border-2 text-lg font-semibold"
    >Get Recommended Now</a
    >
  </div>
</div>

<div *ngIf="isAgentium()" class="bg-agentium_blue-primary">
  <div class="max-w-screen-xl mx-auto text-white py-10 px-4">
    <div class="flex flex-col md:flex-row md:mb-10 text-center md:text-left">
      <div class="grow basis-0 max-w-full mx-auto md:mx-0 mb-10 md:mb-0">
        <img src="../../../assets/agentium-white.png" width="150" height="28" class="mb-5" alt="agentium logo" />
        <div class="flex align-middle">
          <a class="pr-5" href="https://www.linkedin.com/company/trustedchoice/" aria-label="linkedIn"
          ><svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-white" viewBox="0 0 448 512">
            <path
              d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"
            /></svg
          ></a>
          <a class="pr-5" href="https://www.facebook.com/TrustedChoiceAdvantage/" aria-label="facebook"
          ><svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-white" viewBox="0 0 320 512">
            <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" /></svg
          ></a>
          <a class="pr-5" href="https://twitter.com/TC_COMAdvantage" aria-label="x-link"
          ><svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-white" viewBox="0 0 512 512">
            <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" /></svg
          ></a>
          <a href="https://twitter.com/TC_COMAdvantage" aria-label="youtube"
          ><svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 fill-white" viewBox="0 0 576 512">
            <path
              d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"
            /></svg
          ></a>
        </div>
      </div>
      <div class="grow basis-0 max-w-full text-white flex flex-col mb-10 md:mb-0">
        <div class="font-semibold mb-1 text-base">Products</div>
        <a [href]="environment.agentiumUrl + '/agents/'" class="font-light mb-2 hover:underline">Agent Solutions</a>
        <a [href]="environment.agentiumUrl + '/partner-programs/'" class="font-light mb-2 hover:underline">Partner Programs</a>
        <a [href]="environment.agentiumUrl + '/get-a-demo/'" class="font-light mb-2 hover:underline">Get a Demo</a>
        <a [href]="environment.agentiumUrl + '/buy-now/'" class="font-light hover:underline">Buy Now</a>
      </div>
      <div class="grow basis-0 max-w-full flex flex-col mb-10 md:mb-0">
        <div class="font-semibold mb-1 text-base">Resources</div>
        <a href="https://www.momentumedge.com/help-desk/" class="font-light mb-2 hover:underline">Help Desk</a>
        <a href="https://www.momentumedge.com/insurance-markets/" class="font-light mb-2 hover:underline">Market Finder</a>
        <a href="https://www.trustedchoice.com/shoppers" class="font-light mb-2 hover:underline">Live Shopper Feed</a>
      </div>
      <div class="grow basis-0 max-w-full flex flex-col mb-10 md:mb-0">
        <div class="font-semibold mb-1 text-base">Company</div>
        <a [href]="environment.agentiumUrl + '/about/'" class="font-light mb-2 hover:underline">About Agentium</a>
        <a [href]="environment.agentiumUrl + '/our-partners/'" class="font-light mb-2 hover:underline">Our Partners</a>
        <a [href]="environment.agentiumUrl + '/press/'" class="font-light mb-2 hover:underline">Newsroom</a>
        <a [href]="environment.agentiumUrl + '/contact-us/'" class="font-light mb-2 hover:underline">Contact Us</a>
      </div>
    </div>
    <div class="text-center lg:flex">
      Copyright &copy;{{ currentYear() }}, Agentium. All rights reserved.
      <div class="mt-1 lg:mt-0 flex flex-wrap justify-center">
        <a href="#" class="iubenda-cs-preferences-link font-light mb-1 hover:underline mx-3 text-nowrap">Your Privacy Choices</a>
        <span class="iubenda-cs-uspr-link hidden"></span>
        <a href="https://www.iubenda.com/privacy-policy/75803826/full-legal#notice_at_collection" class="font-light mb-1 hover:underline mr-3 text-nowrap">Notice at Collection</a>
        <a href="https://www.momentumedge.com/about-us/privacy-policy/" class="font-light mb-1 hover:underline mr-3 text-nowrap">Privacy Policy</a>
        <a href="https://www.momentumedge.com/about-us/cookie-policy/" class="font-light mb-1 hover:underline mr-3 text-nowrap">Cookie Policy</a>
        <a href="https://www.momentumedge.com/about-us/terms-of-use/" class="font-light mb-1 hover:underline text-nowrap">Terms & Conditions</a>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isMomentumEdge()" class="bg-momentum-royal_purple">
  <div class="max-w-screen-x lmx-auto text-white py-5 px-4 text-center font-bold uppercase tracking-[3px]">
    <span>America's official directory of independent insurance agents, brokers & insurance companies</span>
  </div>
</div>

<div *ngIf="isMomentumEdge()" class="bg-momentum-deep_purple">
  <div class="max-w-screen-xl mx-auto text-white py-10 px-4">
    <!-- Logo -->
    <div class="text-center mb-10">
      <a [href]="environment.wwwUrl">
        <img src="assets/edge-logo-reversed-sm.avif" class="max-w-40 sm:max-w-[180px] inline-block" alt="Momentum Edge logo" height="44" width="180" />
      </a>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10 text-center md:text-left">
      <div class="flex flex-col">
        <div class="font-bold uppercase text-base font-poppins tracking-[1px] mb-4">Products</div>
        <a [href]="environment.wwwUrl + '/independent-agents/'" class="font-light mb-2 hover:underline text-sm">Momentum Edge for Agents</a>
        <a [href]="environment.wwwUrl + '/insurance-companies/'" class="font-light mb-2 hover:underline text-sm">Momentum Edge for Insurance Companies</a>
        <a [href]="environment.wwwUrl + '/claim-it/'" class="font-light hover:underline text-sm">Claim-it Referrals</a>
      </div>
      <div class="flex flex-col">
        <div class="font-bold uppercase text-base font-poppins tracking-[1px] mb-4">Resources</div>
        <a [href]="environment.wwwUrl + '/blog/'" class="font-light mb-2 hover:underline text-sm">Blog</a>
        <a [href]="environment.wwwUrl + '/newsletter/'" class="font-light mb-2 hover:underline text-sm">Newsletter</a>
        <a [href]="environment.wwwUrl + '/insurance-markets/'" class="font-light mb-2 hover:underline text-sm">Find an Insurance Market</a>
      </div>
      <div class="flex flex-col">
        <div class="font-bold uppercase text-base font-poppins tracking-[1px] mb-4">Support</div>
        <a [href]="environment.wwwUrl + '/help-desk/'" class="font-light mb-2 hover:underline text-sm">Help Desk</a>
        <a href="/admin/all-referrals" class="font-light hover:underline text-sm">Agent Log In</a>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10 text-center md:text-left">
      <div class="flex flex-col">
        <div class="font-bold uppercase text-base font-poppins tracking-[1px] mb-4">Company</div>
        <a [href]="environment.wwwUrl + '/about-us/'" class="font-light mb-2 hover:underline text-sm">About Us</a>
        <a [href]="environment.insuredBetterUrl" target="_blank" class="font-light mb-2 hover:underline text-sm">InsuredBetter.com</a>
        <a [href]="environment.insuranceDirectoryUrl" target="_blank" class="font-light mb-2 hover:underline text-sm">InsuranceDirectory.com</a>
        <a [href]="environment.wwwUrl + '/success-stories/'" class="font-light mb-2 hover:underline text-sm">Success Stories</a>
      </div>
      <div class="flex flex-col text-sm">
        <div class="font-semibold mb-2">Momentum Edge</div>
        <div class="font-light mb-1">2262 26th Ave NW</div>
        <div class="font-light mb-2">New Brighton, MN 55112</div>
        <div class="mb-1"><a href="tel:8553720075" class="font-light hover:underline">(855) 372-0075</a> Main</div>
        <div><a href="tel:8553720070" class="font-light hover:underline">(855) 372-0070</a> Customer Support</div>
      </div>
      <div class="flex flex-col items-center md:items-start">
        <div class="flex gap-3 mb-6">
          <a href="https://www.facebook.com/MomentumampEdge" aria-label="facebook" class="group w-10 h-10 rounded-full border border-momentum-royal_purple flex items-center justify-center hover:bg-momentum-royal_purple transition-colors"
          ><svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-momentum-royal_purple group-hover:fill-white" viewBox="0 0 320 512"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/></svg
          ></a>
          <a href="https://www.youtube.com/channel/UCwFsZLU6mahTwtHzrxZnIrw" aria-label="youtube" class="group w-10 h-10 rounded-full border border-momentum-royal_purple flex items-center justify-center hover:bg-momentum-royal_purple transition-colors"
          ><svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-momentum-royal_purple group-hover:fill-white" viewBox="0 0 576 512"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg
          ></a>
          <a href="https://www.linkedin.com/company/momentumamp-edge" aria-label="linkedIn" class="group w-10 h-10 rounded-full border border-momentum-royal_purple flex items-center justify-center hover:bg-momentum-royal_purple transition-colors"
          ><svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 fill-momentum-royal_purple group-hover:fill-white" viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg
          ></a>
        </div>
        <a
          [href]="environment.wwwUrl + '/contact-us/'"
          class="button inline-block px-10 py-2 text-sm font-semibold uppercase tracking-widest text-white bg-transparent hover:bg-momentum-royal_purple border border-white hover:border-momentum-royal_purple transition-colors"
        >Contact Us</a>
      </div>
    </div>
    <div class="max-w-screen-xl mx-auto text-center bg-momentum-royal_purple text-white py-2.5 px-4 mb-14 text-sm">
      <span class="font-medium tracking-[1px]"
      >Are you a business owner or consumer looking to get insured?
        <span class="font-normal">Connect with an independent insurance agent on <a [href]="environment.insuredBetterUrl" class="underline hover:no-underline">InsuredBetter.com</a></span></span
      >
    </div>
    <div class="text-center">
      <div>Copyright &copy;{{ currentYear() }}, Momentum Edge (a NowCerts Inc. company)</div>
      <div class="mt-2 flex flex-wrap justify-center">
        <a href="#" class="iubenda-cs-preferences-link font-light mb-1 hover:underline mx-3 text-nowrap ">Your Privacy Choices</a>
        <span class="iubenda-cs-uspr-link hidden"></span>
        <a href="https://www.iubenda.com/privacy-policy/75803826/full-legal#notice_at_collection" class="font-light mb-1 hover:underline mr-3 text-nowrap ">Notice at Collection</a>
      </div>
      <div class="flex flex-wrap justify-center">
        <a [href]="environment.wwwUrl + '/about-us/privacy-policy/'" class="font-light mb-1 hover:underline mr-3 text-nowrap">Privacy Policy</a>
        <a [href]="environment.wwwUrl + '/about-us/cookie-policy/'" class="font-light mb-1 hover:underline mr-3 text-nowrap">Cookie Policy</a>
        <a [href]="environment.wwwUrl + '/about-us/terms-of-use/'" class="font-light mb-1 hover:underline text-nowrap">Terms & Conditions</a>
      </div>
    </div>
  </div>
</div>
